export default __webpack_public_path__ + "locales/en.1aeace78e8b3d565aca544346be48b29.json";